import { useEffect, useState } from 'react';
import { useCatalog } from '~/hooks/use-catalog';
import { Image } from '~/types';

const useProductMainImage = ({ slug, sku }: { slug: string; sku: string }) => {
  const { allKits, allProducts } = useCatalog();

  const [image, setImage] = useState<Image | null>(null);

  useEffect(() => {
    const product = allProducts?.find((p) => p?.slug === slug);
    const kit = allKits?.find((k) => k?.slug === slug);

    const image = product?.variants?.find((v) => v?.sku === sku)?.mainImage ?? kit?.mainImage;

    if (image) setImage(image);
  }, [allProducts, allKits, sku, slug]);

  return { image };
};

export default useProductMainImage;
